import type { PayloadAction } from "@reduxjs/toolkit";

/**
 * Shared parts of RequestHeaderSlice — plan §5.2. The smallest module of the migration:
 * one state field, 2 identical reducers, 0 divergent. Web adds `updateRequestHeaderSlice`
 * and the logout `extraReducers`.
 *
 * ⚠️ The slice `name` is `"reuqestHeaderData"` — a TYPO, present in both apps, and it is the
 * action-type prefix AND the reducer key's persist identity. Preserved deliberately in both
 * platform files. Correcting it is a persist migration, not a cleanup.
 *
 * ⚠️ `action` must be `PayloadAction<any>`, never `any` — see the ledger.
 */
export interface SharedProps {
  data: any
}

export const sharedInitialState: SharedProps = {
  data: {}
}

/** Identical in both apps — every mobile reducer is here. */
export const sharedReducers = {
  saveRequestHeaderData: (state: SharedProps, action: PayloadAction<any>) => {
    state.data = action.payload
  },
  // No `action` param in either app — RTK generates a no-payload creator. Keep it that way.
  resetRequestHeaderData: (state: SharedProps) => {
    state.data = {}
  },
};
